import { render, staticRenderFns } from "./attractions.vue?vue&type=template&id=7fe7a492&"
import script from "./attractions.vue?vue&type=script&lang=js&"
export * from "./attractions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports